
import Vue from 'vue'
import {Component, Prop, Model, Watch} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'

const conseillerModule = namespace('conseiller')

@Component
export default class SelectConseiller extends Vue {
  @Prop(String) placeholder!: string
  @Prop() value!: any
  @Prop() afterOption!: any

  @conseillerModule.Getter('conseillersGetter') conseillers: any
  @conseillerModule.Action('getConseillersAction') getConseillers: any

  get options() {
    return this.conseillers || []
  }

  get selected() {
    return this.value
  }

  set selected(v) {
    this.$emit('input', v)
  }

  mounted() {
    if (!this.conseillers) this.getConseillers()
  }

  onChangeHandler(e) {
    this.$emit('change', e)
  }
}
